export const lngDetect = (obj) => {
  let selected_lng = localStorage.getItem("lang") || "en";

  // window.addEventListener("lngChange", (e) => {
  //   selected_lng = e.detail?.language || "en";
  //   console.log(e);
  // });

  try {
    if (
      typeof obj === "object" &&
      obj !== null &&
      Object.keys(obj).length > 0
    ) {
      return obj[selected_lng] || obj["en"] || Object.values(obj)[0] || "";
    } else if (typeof obj === "string") {
      return obj;
    }
  } catch (error) {
    console.error("lngDetect error:", error);
  }

  return "-";
};
